<template>
  <section>
    <div class="px-4 py-5 sm:px-6">
      <h3 class="text-lg font-medium leading-6 text-gray-900">
        Anleitung
      </h3>
      <p class="mt-1 max-w-2xl text-sm text-gray-500">
        Erfahre Schritt für Schritt, wie diese Methode umgesetzt wird
      </p>
    </div>
    <article class="border-t border-gray-200 px-4 py-5 sm:p-0">
      <ActionList :actions="results" />
    </article>
  </section>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useFetchResources } from '@/client/actions';

const props = defineProps({practice: Object});

const parent = computed(() => props.practice.id);
const target = computed(() => '/api/practices/' + parent.value + '/actions');

const action = useFetchResources(target);

const { results, fetch, fetching, empty } = action;

const mounted = onMounted(fetch);
const watcher = watch(parent, fetch);
</script>
